<!--
 * @Author: Chenhw2017 1272617071@qq.com
 * @Date: 2024-06-11 13:57:10
 * @LastEditors: Chenhw2017 1272617071@qq.com
 * @LastEditTime: 2024-06-12 17:44:46
 * @FilePath: /partner.chaoyongtuan.com/src/views/settings/message/components/index/compose/inputCom.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-form ref="form" :model="form" @submit.native.prevent>
		<el-form-item prop="value" :rules="rules">
			<el-input :style="info.style" v-model="form.value" placeholder="请输入"></el-input>
		</el-form-item>
	</el-form>
</template>

<script>
export default {
	props: {
		info: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	computed: {
		rules() {
			return this.info.pattens.map(item => {
				return {
					validator: (rule, value, callback) => {
						var reg = new RegExp(item.patten);
						if (reg.test(value)) {
							callback();
						} else {
							callback(item.check_error);
						}
					},
					message: '',
					trigger: 'blur',
				};
			});
		},
	},
	data() {
		return {
			form: {
				value: this.info.select_value,
			},
		};
	},
	methods: {
		getValue() {
			return new Promise((res, rej) => {
				this.$refs['form'].validate(valid => {
					if (valid) {
						res(this.form.value);
					} else {
						rej();
					}
				});
			});
		},
	},
};
</script>

<style lang="less" scoped>
/deep/ .el-form-item {
	margin-bottom: 0 !important;
}
</style>
